exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!./components/privacyfabrick/styles.css
// module id = 1174
// module chunks = 0